import { animate, style, transition, trigger } from '@angular/animations';

/**
 * Fade-in/fade-out aplicado ao overlay e à caixa de todo diálogo (`ai-dialog`).
 *
 * Como todos os diálogos da aplicação são renderizados por este componente
 * (confirmações de ação, modais de seleção, etc.), a animação vale para todos.
 * O `:leave` exige que a destruição do diálogo seja adiada até o fim do fade
 * (ver `DialogManager.close`).
 */
export const dialogFade = trigger('dialogFade', [
    transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms ease', style({ opacity: 1 })),
    ]),
    transition(':leave', [animate('500ms ease', style({ opacity: 0 }))]),
]);

/** Duração (ms) do fade-out — usada para adiar a destruição do diálogo. */
export const DIALOG_FADE_MS = 500;
